var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchbar",style:({
    transform: ("translateY(" + (_vm.shown ? '0' : '40px') + ") scaleY(" + (_vm.shown ? 1 : 0) + ") "),
  })},[_c('div',{staticClass:"body",style:({
      marginRight: ("calc(" + _vm.triangleMargin + " / 2)"),
    })},[_c('input',{ref:"searchInput",attrs:{"type":"text","autocomplete":"off","spellcheck":"false"},on:{"input":function($event){return _vm.$emit('change', $event.target.value)}}})]),_c('div',{staticClass:"triangle",style:({
      marginRight: _vm.triangleMargin,
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }